import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { NotesAppContextDirective } from '@modules/notes/directives/app-notes-app-context.directive';
import { Notebook } from '@modules/notes/types/notebook';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-notebook-shared',
  templateUrl: './notebook-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NotesAppContextDirective,
    IconComponent,
    DateFormatPipe,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
    ItemDescriptionComponent,
  ],
})
export class NotebookSharedComponent extends SharedBaseComponent<Notebook> {
  protected override stitchType = StitchType.NOTEBOOK;

  protected get notebook(): Notebook {
    return this.stitchItem?.();
  }
}
